function normalizeString(value) {
  if (value == null) return null;
  const normalized = String(value).trim();
  return normalized || null;
}

export function getMatchServerLocation({ matchData, serverLocations = [] }) {
  const regionId =
    normalizeString(matchData?.assignedAgentRegion) ||
    normalizeString(matchData?.location);

  if (!regionId) return null;

  const location = Array.isArray(serverLocations)
    ? serverLocations.find((entry) => {
        const entryId =
          normalizeString(entry?.id) || normalizeString(entry?.awsRegion);
        return entryId === regionId;
      })
    : null;

  if (!location) {
    return {
      regionId,
      label: regionId,
      flagImageUrl: null,
      country: null,
    };
  }

  return {
    regionId,
    label:
      normalizeString(location.displayName) ||
      normalizeString(location.country) ||
      regionId,
    flagImageUrl: normalizeString(location.flagImageUrl),
    country: normalizeString(location.country),
  };
}
